import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject, of } from "rxjs";

import { AuthServices } from "../auth.service";
import { Injectable } from "@angular/core";
import { endpoints } from "src/app/_config/url-endpoint";

const yachtPartnerUrl = endpoints.yacht.partnerUrl;

@Injectable({
  providedIn: "root",
})
export class YachtPartnerService {
  private savePartnerVal = new Subject<any>();

  constructor(private http: HttpClient, private authService: AuthServices) {}

  /**
   * Partners
   *
   * @param {string} queryString
   * @returns {Observable<any>}
   * @memberof YachtPartnerService
   */

  getPartners(queryString): Observable<any> {
    let url = `${yachtPartnerUrl}?${queryString}`;
    return this.http.get(url, this.authService.getAccessHeaders());
  }

  /**
   * Create Partner
   *
   * @param {string} body
   * @returns {Observable<any>}
   * @memberof YachtPartnerService
   */

  createPartner(body): Observable<any> {
    return this.http.post(`${yachtPartnerUrl}`, body, this.authService.getAccessHeaders());
  }

  /**
   * Partner Details
   *
   * @param {string} partnerId
   * @returns {Observable<any>}
   * @memberof YachtPartnerService
   */

  getPartnerDetails(partnerId): Observable<any> {
    return this.http.get(yachtPartnerUrl + "/" + partnerId, this.authService.getAccessHeaders());
  }

  /**
   * Edit Partner
   *
   * @param {string} partnerId
   * @param {string} body
   * @returns {Observable<any>}
   * @memberof YachtPartnerService
   */

  editPartner(partnerId, body): Observable<any> {
    return this.http.patch(yachtPartnerUrl + "/" + partnerId, body, this.authService.getAccessHeaders());
  }

  /**
   * Partner Count
   *
  
   * @returns {Observable<any>}
   * @memberof YachtPartnerService
   */

  getPartnerCount(tenantId): Observable<any> {
    let url = `${yachtPartnerUrl}/status-count?tenantId=${tenantId}`;
    
    return this.http.get(url, this.authService.getAccessHeaders());
  }

  /**
   * Change Partner Status
   *
   * @param {string} partnerId
   * @param {string} body
   * @returns {Observable<any>}
   * @memberof YachtPartnerService
   */

  changePartnerStatus(partnerId, body): Observable<any> {
    return this.http.post(
      endpoints.yacht.changeYachtPartnerStatus + partnerId,
      body,
      this.authService.getAccessHeaders(),
    );
  }

  /**
   * Partner
   *
  
   * @returns {Observable<any>}
   * @memberof YachtPartnerService
   */

  getPartner(): Observable<any> {
    return this.http.get(endpoints.partnerPage.getPartner, this.authService.getAccessHeaders());
  }

  /**
   * DownloadFile
   *
   * @param {string} queryString
   * @returns {Observable<any>}
   * @memberof YachtPartnerService
   */

  downloadFile(queryString): Observable<any> {
    const url = `${yachtPartnerUrl}/export?${queryString}`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.get(url, {
      headers: (this.authService.getAccessHeaders() as { headers: HttpHeaders }).headers,
      responseType: "blob",
    });
  }

  /**
   * Update SPOC Phone Number
   *
   * @param {string} partnerId
   * @param {{ countryCode: string; mobileNumber: string }} body
   * @returns {Observable<any>}
   * @memberof YachtPartnerService
   */
  updateSpocPhone(partnerId: string, body: { countryCode: string; mobileNumber: string }): Observable<any> {
    const url = `${endpoints.yacht.updateSpocPhoneUrl}/${partnerId}/phone`;
    return this.http.put(url, body, this.authService.getAccessHeaders());
  }

  /**
   * Update SPOC Email Address
   *
   * @param {string} partnerId
   * @param {{ email: string }} body
   * @returns {Observable<any>}
   * @memberof YachtPartnerService
   */
  updateSpocEmail(partnerId: string, body: { email: string }): Observable<any> {
    const url = `${endpoints.yacht.updateSpocEmailUrl}/${partnerId}/email`;
    return this.http.put(url, body, this.authService.getAccessHeaders());
  }

  public setRefreshPartner(data: any) {
    this.savePartnerVal.next({ result: data });
  }

  public getRefreshPartner(): Observable<any> {
    return this.savePartnerVal.asObservable();
  }
}
